import { useConfig } from '@packages/utilities';
import { useHash } from '../useHash';

export const useWriteCustomerRatingEnabled = () => {
  const {
    customerRatings: { ratingButtonEnabled, forceEnableRatingButtonParam },
  } = useConfig();
  const hash = useHash();

  if (ratingButtonEnabled) return true;

  if (
    ratingButtonEnabled === false &&
    forceEnableRatingButtonParam !== null &&
    hash.get(forceEnableRatingButtonParam) === 'true'
  ) {
    return true;
  }

  return false;
};
